import "./SSOLogin.css";
import "./BGAnimation.css";
import "./gradientAnim.css";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { service } from "../services/service";
import md5 from "md5";
import Swal from "sweetalert2";
import { Alert, Backdrop, Box, Button, CircularProgress, Grid, IconButton, Snackbar, TextField, Typography } from "@mui/material";
import { Margin } from "@mui/icons-material";
import { makeStyles } from '@mui/styles';
import LoginIcon from '@mui/icons-material/Login';

// import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PersonIcon from '@mui/icons-material/Person';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import Carousel from "./Carousel";
import LoginScreen from "./LoginScreen";
import Loader from "./Loader";
import LoginScreen_2 from "./LoginScreen_2";

const useStyles = makeStyles((theme) => ({
  textField: {
    '& input::placeholder': {
      fontSize: '12px', // Adjust the font size as needed
    },

  },
}));
function SSOLogin() {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null)
  const [lookAtPass, setLookAtPass] = useState(false)
  const [vertical, setVertical] = useState("bottom")
  const [horizontal, setHorizontal] = useState("right")
  const [loginAttempt, setLoginAttempt] = useState(false)
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState();
  const [password, setPassword] = useState();
  const [companyToken, setCompanyToken] = useState("");
  const [passwordType, setPasswordType] = useState(true)
  const [companyName, setCompanyName] = useState('')
  const [companyLogo, setCompanyLogo] = useState('')
  const [openForgotPassword, setForgotPassword] = useState(false)
  const [forgottenPassword, setForgottenPassword] = useState("")
  const [token, setToken] = useState({})
  const [userName, setUserName] = useState("")

  const [loginUrl, setLoginUrl] = useState("")
  const location = useLocation()
  const [loader, setLoader] = useState(false)






  const classes = useStyles();
  console.log(window?.location.href, "ASDASDHASDHASHDASDAS")



  const getInitalInfo = async (forNck) => {
    const pathArray = location.pathname.split('/');
    const companyIdentifier = pathArray[1];

    if (forNck === "HardCodedForNKC") {
      setCompanyLogo("https://nyggs-bucket.s3.ap-south-1.amazonaws.com/1695796119595_NKC%20side%20menu.png");
      setCompanyName("NKC PROJECTS PVT. LTD.");
      setCompanyToken("FDGVB@^&2");
    } else {
      // try {
      const apiEndpoint = "employee/whiteListed/v2/getCompanyConfigV2";
      console.log("Current URL:", window.location.href);

      // Set the login URL
      setLoginUrl(window.location.href);

      const res = await service.get(apiEndpoint);  // Use async/await for clarity
      const { data } = res;

      if (data?.data) {
        const { headerLogo, companyName, companyToken } = data.data;

        setCompanyLogo(headerLogo);
        setCompanyName(companyName.toUpperCase());
        setCompanyToken(companyToken);
        console.log("Company Token:", companyToken);
      } else {
        console.error("Invalid data response", res);
      }
      // } catch (error) {
      //   console.error("Error fetching company config:", error);
      // }
    }
  };

  // useEffect(() => {
  //   console.log("ASDKAJSDKASJHDKASJDHASDAD", window.location.href == 'http://localhost:3001/');
  //   if ((window.location.href === "https://nkcsso.nyggs.com" || window.location.href === "https://nkcsso.nyggs.com/")) {
  //     getInitalInfo("HardCodedForNKC")
  //   } else {
  //     getInitalInfo("Normal")
  //   }
  // }, [])


  useEffect(() => {
    // Store current origin for reuse
    const currentOrigin = window.location.origin;
    console.log("Current Origin:", currentOrigin);

    // Check if the currentOrigin starts with the specified domain
    const configType = currentOrigin.startsWith("https://nkcsso.nyggs.com") ? "HardCodedForNKC" : "Normal";
    getInitalInfo(configType);

    setLoader(true)
    setTimeout(() => {
      setLoader(false)
    }, 1500);

  }, []);


  console.log("ASDHAKSHDKASHD", loginUrl);

  const navigateToModules = async (e) => {
    debugger
    e?.preventDefault()
    const payload = {
      companyToken: companyToken,
      password: md5(password || ""),
      username: user || ""
    }

    console.log("ASDKHASDGHAJSHD", payload);
    await service.authenticate(payload).then((response) => {
      debugger
      console.log("OUTERRESPONSE", response);

      if (response.status === 200) {

        console.log("ASDLHAKSDHKAHSDKHAS", response);

        // navigate("/modulesSelection", {token:response?.data?.token});
        // // window.location.href = `/modulesSelection?token=${response?.data.token}`

        if (response?.data?.token) {
          debugger
          navigate(`/ModulesSelection?token=${response?.data?.token}`, { state: { loginUrl: window.location.href, logo: companyLogo } })
          localStorage.setItem("userName", response?.data?.firstName)
          localStorage.setItem("companyToken", response?.data?.token)

        }
        console.log("ASDAJSDHAJSJDKASJD", response?.data)
        setLoginAttempt(response?.data?.status === 200 ? true : false)
        setOpen(true)
        if (response?.data?.status !== 200) {
          setLoginAttempt(false)
          setErrorMessage({ status: response?.data?.status, msg: response?.data?.message })
          // setTimeout(() => {
          //   setErrorMessage(null)
          // }, 2000);
        }

      } else {

        setOpen(true)
        setLoginAttempt(false)
        setErrorMessage({ status: response?.status, msg: response?.message || "Un-Authorised" })

      }
    }).catch((error) => console.log(error));

    // const payload={
    //   companyToken: companyToken,
    //     password: md5(password),
    //     username: user
    // }
    // service.authenticate(payload).then(response=>{
    //   console.log("ASKDHAKDHAKHSDKAHDS",23);
    //   if(response.status===200)
    //   {
    //     window.location.href = `/modulesSelection?token=${response?.data.token}` 
    //   }
    //   else{
    //     alert("Invalid user");
    //   }
    // }).catch((error) => console.log(error));
  }


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  console.log("ASDKAKSDHAKSHDKSAH", token, errorMessage);

  // useEffect(()=>{
  //   navigate(`/modulesSelection?token=${token}`, {state:{userName:response?.data?.company?.name}})
  // },[token && token.length>1])



  var setCookies = (name, value, daysToExpire) => {
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (daysToExpire) {
      const expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
      cookie += `; expires=${expirationDate.toUTCString()}`;
    }

    document.cookie = cookie;
  };



  console.log("SAKHASKDHKSHAD", companyLogo, companyName, companyToken);

  const getForgotPasswordHtml = () => {
    return (<div>
      <input type="email" id="email" class="swal2-input" placeholder="Entr your email"></input>
    </div>)
  }

  console.log("ADKHAJDHKASHDASKH", companyLogo);
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Enter' && (user !== '' || password !== '')) {
        navigateToModules(e);
      }
    };

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [user, password]);


  console.log("asdgsahdasd", 123);




  return (
    <div className="SSOLogin" >
      <div className="super-container" style={{}}>
        {/* =========================================================== OLD LOGIN====================================== */}

        {/* <div className="container" >
          <div className="logo" >
            <h2 style={{ textAlign: "center", fontWeight: 900, marginTop: "2px" }}>Login</h2>
            <img
              src={companyLogo}
              // src="https://nyggs-bucket.s3.ap-south-1.amazonaws.com/1695796119595_NKC%20side%20menu.png"
              alt="Company_Logo" style={{ padding: "10px", width: "260px", marginBottom: "10px", marginTop: "-10px" }} />
          </div>
          <div>
            <Grid container>
              <Grid item xs={12}>
                <Box
                  component="form"
                  sx={{
                    '& > :not(style)': { m: 0.8, width: '30ch' },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <Typography sx={{ fontSize: "14px", fontWeight: "800" }}>Employee Code</Typography>
                  <TextField
                    id="employee-code"
                    name="username"  // Set name attribute to "username" to make it more recognizable for the browser
                    type="text"
                    variant="standard"
                    placeholder="Type Your Employee Code"
                    InputProps={{
                      startAdornment: (
                        <PersonIcon style={{ color: "darkgray", paddingRight: "4px", fontSize: "20px" }} />
                      ),
                      sx: { fontSize: '12px' },
                    }}
                    onChange={(e) => setUser(e.target.value)}
                    autoComplete="username" // Helps the browser know this is for the employee code
                    autoCapitalize="none"   // Ensures no auto-correction on the employee code
                    autoCorrect="off"       // Helps prevent autofill from showing saved data
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Box
                  component="form"
                  sx={{
                    '& > :not(style)': { m: 0.8, width: '30ch' },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <Typography sx={{ fontSize: "14px", fontWeight: "800" }}>Password</Typography>
                  <TextField
                    type={lookAtPass ? "text" : "password"}
                    id="password"
                    name="password" // Set name attribute to "password" to make it more recognizable for the browser
                    variant="standard"
                    placeholder="Type Your Password"
                    InputProps={{
                      startAdornment: (
                        <VpnKeyIcon style={{
                          color: "darkgray",
                          paddingRight: "4px",
                          fontSize: "18px",
                        }} />
                      ),
                      endAdornment: (
                        <IconButton
                          onClick={() => password?.length > 0 && setLookAtPass(!lookAtPass)}
                        >
                          {!lookAtPass ? <VisibilityOffIcon style={{ fontSize: "20px", color: password?.length > 0 ? "darkgrey" : "lightgray" }} /> :
                            <RemoveRedEyeOutlinedIcon style={{ fontSize: "20px", color: password?.length > 0 ? "darkgrey" : "lightgray" }} />}
                        </IconButton>
                      ),
                      sx: { fontSize: '12px' },
                    }}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"  // Helps the browser know this is for the password
                    autoCapitalize="none"
                    autoCorrect="off"
                  />
                </Box>
              </Grid>
            </Grid>

            <div className="form-grou">
              <button
                type="submit"
                style={{
                  position: "relative",
                  marginTop: 22,
                  marginBottom: 10,
                  width: "102%",
                  // padding: "15px 30px",
                  backgroundColor: "#007BFF",
                  borderRadius: "6px",
                  backgroundColor: !hovered ? "#007BFF" : "#0062cc",
                  outline: "none",
                  border: "none",
                  color: "white",
                  fontWeight: 700,
                  cursor: "pointer",
                  transition: "background-color 0.3s ease-in-out",
                }}
                onClick={navigateToModules}
                onMouseOver={(e) => {
                  setHovered(true)
                }}
                onMouseOut={(e) => {
                  setHovered(false)
                }}
              >
                <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", backgroundColor: hovered ? "#0062cc" : "#007BFF", padding: "15px 30px", }}
                >
                  <span
                    style={{
                      transition: "transform 0.3s ease-in-out",
                      transform: hovered ? "translateX(-5px)" : "translateX(0)",
                    }}
                  >
                    Log In
                  </span>
                  {hovered && (
                    <LoginIcon
                      style={{
                        fontSize: "18px",
                        position: "absolute",
                        left: 160, // Adjust as needed
                        transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
                        opacity: hovered ? 1 : 0,
                        transform: hovered ? "translateX(0)" : "translateX(-10px)",
                      }}
                    />
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
        <div>
          <img
            src="https://ota.nyggs.com/img/NYGGSERPMODULE512.png"
            className="img-style"
          />
        </div> */}
        {/* ================================================================================================================= */}

        {/* ===============================================NEW LOGIN *========================================= */}
        {loader && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backdropFilter: 'blur(6px)',
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: loader ? 1 : 0,
              transition: 'opacity 0.5s ease',
              pointerEvents: loader ? 'auto' : 'none', // so it's not clickable when hidden
            }}
          >
            <Loader />
          </div>
        )}
        <div>

          {/* <LoginScreen companyLogo={companyLogo} setPassword={setPassword} setUser={setUser} password={password} user={user} navigateToModules={navigateToModules} /> */}

          <LoginScreen_2 companyLogo={companyLogo} setPassword={setPassword} setUser={setUser} password={password} user={user} navigateToModules={navigateToModules}/>

        </div>
        {/* ============================================================================================================= */}

      </div>
      <div className="ripple-background">
        <div className="circle xxlarge shade1"></div>
        <div className="circle xlarge shade2"></div>
        <div className="circle large shade3"></div>
        <div className="circle mediun shade4"></div>
        <div className="circle small shade5"></div>
      </div>
      <div style={{ position: "absolute", right: 2, bottom: 2, color: "white", padding: "8px 14px", fontSize: "14px", borderRadius: 4 }}>Version : 2.1.1</div>
      <div style={{ position: "absolute", top: "50%", left: "50%" }}>

        {openForgotPassword ? <Backdrop open={openForgotPassword} >

          <Grid sx={{ border: "1px solid white", minWidth: "600px", backgroundColor: "white", padding: "10px 20px", borderRadius: "5px", boxShadow: "5px 5px 10px #595959" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>Forgot Password</Typography>
            <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1, fontSize: 15, color: "gray" }}>Please enter your registered E-mail address to get the reset password link.</Typography>
            <br></br>
            <TextField id="outlined-basic" label="Email Address" variant="outlined" style={{ width: "100%" }} size="small" value={forgottenPassword} onChange={(e) => setForgottenPassword(e.target.value)} type="email" />
            <div style={{ display: "flex", width: "100%", textAlign: "right", flexFlow: "row-reverse", marginTop: 10, gap: 10 }}>

              <Button variant="contained" onClick={() => setForgotPassword(false)}>Submit</Button>
              <Button variant="outlined" onClick={() => setForgotPassword(false)}>Cancel</Button>
            </div>
          </Grid>

        </Backdrop> : null}

      </div>
      {console.log("ASDKAJSDAKJSDKAJSDAKJD", errorMessage)}
      <Snackbar open={open} anchorOrigin={{ vertical, horizontal }} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={`${loginAttempt ? "success" : "error"}`} sx={{ width: '100%' }}>
          {loginAttempt ? "Login Success" : errorMessage?.msg?.length > 0 ? errorMessage?.msg : "Employee Code or Password is wrong !"}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default SSOLogin;
